"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbHybridAuthenticator = void 0;
const web_ui_security_1 = require("@gruposantander/web-ui-security");
class MbHybridAuthenticator extends web_ui_security_1.BaseAuthenticator {
    constructor(session, getAccessToken) {
        super(session);
        this.doLogin = async () => {
            const accessToken = await this.getAccessToken();
            return { accessToken };
        };
        this.doLogout = async () => {
            return Promise.resolve();
        };
        this.getAccessToken = getAccessToken;
    }
}
exports.MbHybridAuthenticator = MbHybridAuthenticator;
//# sourceMappingURL=index.js.map